export default "__VITE_ASSET__BlKb9RAT__"